// @ts-nocheck

import { type StoreType } from '../../../types/redux';
import { type GenericAction } from '../../../types/redux';
import { recomputeNextGRBasketState } from '../actions/basket';
import { GRStateActionTypes } from '../types/actions/gr';

const handledActionTypes = [GRStateActionTypes.UPDATE_STATE];

const GRMiddleware =
  () =>
  ({ dispatch }: StoreType) =>
  (next: (action: GenericAction) => unknown) =>
  async (action: GenericAction) => {
    if (handledActionTypes.indexOf(action.type) !== -1) {
      const { type: actionType } = action;

      if (actionType === GRStateActionTypes.UPDATE_STATE) {
        const nextedFlow = next(action);
        dispatch(recomputeNextGRBasketState());
        return nextedFlow;
      }
    }

    return next(action);
  };

export default GRMiddleware;
